/** =========================================================
 * Module: items-filter-alert.directive.js
 * Data table column filter
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsTableFilter', itemsTableFilter);

  itemsTableFilter.$inject = ['$api'];

  function itemsTableFilter($api) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-table-filter.html',
      link: link,
      scope: {
        model: '=',
        action: '=',
        name: '=?'
      }
    };

    return directive;

    function link($scope) {
      $scope.opt = null;
      $scope.opts = [];

      $api.resource({
        model: $scope.model
      }).then(function (response) {
        $scope.$applyAsync(function () {
          $scope.opts = response.data;
        });
      }, Raven.captureException);
    }
  }
})();
